(function () {
    'use strict';

    angular.module("imApp").factory("poCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getPoCreate: function (parms) {
                return $ihttp.post({
                    method: 2441,
                    parameters: parms || {}
                });
            },
            changedProdId: function (edit) {
                return $ihttp.post({
                    method: 2442,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2443,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
